import { useEffect, useState } from "react";
import authService from "../services/AuthService";

const MIN_DISPLAY_MS = 3200; // ensure at least one full message cycle is visible
const FADE_MS = 500;

export type WarmupPhase = "loading" | "fading" | "ready";

export default function useWarmup() {
  const [phase, setPhase] = useState<WarmupPhase>("loading");

  useEffect(() => {
    const start = Date.now();

    async function warmup() {
      // Run warmup ping and startup token refresh in parallel.
      // The silent refresh attempts to renew an expired Entra token using the
      // cached MSAL account + active Entra session cookie, so users who return
      // after a computer restart are logged back in without a redirect to login.
      await Promise.allSettled([
        fetch(import.meta.env.VITE_ADMIN_API_URL + "/warmup", { method: "post" }).catch(() => {}),
        !authService.isAuthenticated() && authService.isEntraSession()
          ? authService.entraTokenRefresh().catch(() => {})
          : Promise.resolve(),
      ]);

      const elapsed = Date.now() - start;
      const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);

      // Ensure splash shows for at least MIN_DISPLAY_MS so it doesn't flash
      setTimeout(() => {
        setPhase("fading");
        // After fade-out completes, mark ready
        setTimeout(() => setPhase("ready"), FADE_MS);
      }, remaining);
    }
    warmup();
  }, []);

  return { phase };
}
